/* eslint-disable max-len */

import React, { Suspense, useCallback, useEffect, useRef, useState } from 'react';
import CardHeader from '../../../components/CardHeader';
import TopBarWithShadow from '../../../components/TopBar/TopBarWithShadow';
import InvoiceIssueStatusTable from './Components/InvoiceIssueStatusTable';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
import { useSearchParams } from 'react-router-dom';
import { dataService } from '../../../services/data.services';
import { formatAdjustedDate } from '../../../CommonMethods/formatDate';
import CustomOverLay from '../../../components/CustomOverlay';
import Loader from '../../../components/Loader';
import { ShimmerTitle } from 'react-shimmer-effects'

const InvoiceIssueStatus = () => {
    const [loading, setLoading] = useState(true);
    const [isSectionIssued, setIsSectionIssued] = useState(false);
    const [refreshLoading,setRefreshLoading] = useState(false);
    const [loadingTable, setLoadingTable] = useState(false);
    const [bulkTransaction, setBulkTransaction] = useState()
    const [bulkInvoiceDetails, setBulkInvoiceDetails] = useState([]);
    const [searchParams,setSearchParams] = useSearchParams();
    const [totalRecords, setTotalRecords] = useState()
    const isFirstLoad = useRef(true);

    const getBulkInvoiceList = useCallback(async () => {
        // if(searchParams?.get('search') === null){
        //     setsearchFieldDebounce('')
        // }
        // Continue with the rest of the function after classes and sections are set
            
        try {

            if (isFirstLoad.current) {
                setLoading(true);
                isFirstLoad.current = false;
            } else {
                setLoading(false);
            }
            setRefreshLoading(true)
            setLoadingTable(true);  
            let pageNumber = searchParams.get("student_page_number") || "1";
            const branch_id = await GetBranchId()
            let search = searchParams.get("search");
            let filter = searchParams.get("filter");
            let endpoint = `invoice/view-bulk-issue?transaction_id=${searchParams.get(
                "transaction_id"
            )}&branch_id=${branch_id}&page_number=${pageNumber}`;
            if (filter !== null && filter.trim() !== "") {
                endpoint += `&filter=${filter}`;
            }
            if (search !== null && search.trim() !== "") {
                endpoint += `&search=${encodeURIComponent(search)}`;
            }
            const response = await dataService.GetAPI(endpoint)
            const temp = response?.data?.data?.transaction
            const temp2 = response?.data?.data?.issue_details;
            console.log(temp)
            setBulkTransaction(temp);
            if (temp.section_name !== "") {
                setIsSectionIssued(true)
            }
            setBulkInvoiceDetails(temp2);
            setTotalRecords(response?.data?.data?.pagination?.total_records);
            
            // const temp3 = response?.data?.data?.all_total_count
            // const temp4 = response?.data?.data?.report_total
            
            // setBulkInvoiceCount(temp2);
            // setFeeCollectionTotalCount(temp3)    
            // setReportTotal(temp4)
        } catch(error) {
            console.log(error)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        } finally{
            setLoading(false)
            setLoadingTable(false);
            setRefreshLoading(false);
            // updateFilterCheckBox();
        }
    }, [searchParams]);
    
    

    const handleRefresh = () => {
        getBulkInvoiceList();
    }
    const handleOnClickPageNumber = (pageNum) => {
        console.log("skjdnksjd", searchParams);
        const params = Object.fromEntries(searchParams);
        setSearchParams({ ...params, student_page_number: pageNum.selected + 1 });
    };
    
    useEffect(() => {
        getBulkInvoiceList();
    }, [searchParams]);

    return (
        <CardHeader noPadding>
            <TopBarWithShadow
                Tittle="Invoice Issue Status"
                isback={true}
                backLocation={`/student-master/invoice-list/bulk-invoice-history?${searchParams.toString()}`}
                rightContent={
                    <div className="flex items-center gap-2">
                        {loading ? (
                            <div className="w-[200px]">
                                <p className="text-2xl font-bold text-[#031624]"><ShimmerTitle line={1} gap={0} variant="secondary" className="w-full mb-0" /></p>
                            </div>) 
                            : 
                            (
                                <span className="text-[#106EB4] font-semibold" id="status_text">
                                    Status: {bulkTransaction?.transaction_status === "in_progress"
                                        ? "In Progress ..."
                                        : bulkTransaction?.transaction_status === "completed"
                                            ? "Completed"
                                            : bulkTransaction?.transaction_status}
                                    {bulkTransaction?.transaction_status === "in_progress" && (
                                        <button
                                            disabled={refreshLoading}
                                            id="refresh_status_btn"
                                            className="view-actn-btn"
                                            onClick={handleRefresh}
                                            style={{ 'min-width': '95px', 'margin-left':'25px' }}
                                        >
                                            Refresh
                                        </button>
                                    )}
                                </span>
                            )
                        }
                    </div>
                }
            >
            </TopBarWithShadow>
            <Suspense fallback={<CustomOverLay Active text="Loading..." classKey="flex flex-col justify-center items-center sidebarOpenedOverlay" />}>
                {loading ? (
                    <CustomOverLay Active text="Loading..." classKey="flex flex-col justify-center items-center sidebarOpenedOverlay" />
                ) : bulkTransaction ? (
                    <div className="h-[calc(100vh-0px)] overflow-y-auto mb-5">
                        <div className="w-full flex justify-center mt-6">
                            <div className="flex w-[95%] max-w-2xl justify-between items-center
                                bg-white  border border-[#EAECF0] px-4 py-4 shadow-sm" id="invoice-issue-summary-bar">
                                <div className="">
                                    Date of Issue <span className="font-semibold ml-3">
                                        {formatAdjustedDate(bulkTransaction?.issue_date)}</span>
                                </div>
                                <div className="text-base font-normal  flex items-center gap-2">
                                    AY{' '}
                                    <span className="font-semibold ml-3">
                                        <span className="font-semibold ml-3">
                                            {`${bulkTransaction?.academic_year}, ${bulkTransaction?.class_name}${bulkTransaction?.section_name ? `, ${bulkTransaction.section_name}` : ''}`}
                                        </span>
                                    </span>
    
                                </div>
                            </div>
                        </div>
                        <div className="w-full flex justify-center mt-6 mb-4">
                            <div className="flex border  divide-x bg-white">
                                <div className="px-8 py-4 text-center" onClick={() => setSearchParams({ ...Object.fromEntries(searchParams), filter: '' })}>
                                    <div className=" text-base">Total # of students</div>
                                    <div className=" text-lg  underline cursor-pointer">
                                        {bulkTransaction?.total_students}
                                    </div>
                                </div>
                                {bulkTransaction?.transaction_status !== "completed" && 
                                <div className="px-8 py-4 text-center">
                                    <div className=" text-base"># invoices in progress</div>
                                    <div className=" text-lg  underline cursor-pointer">
                                        {bulkTransaction?.in_progress_count}
                                    </div>
                                </div>}
    
                            
                                <div className="px-8 py-4 text-center cursor-pointer" onClick={() => setSearchParams({ ...Object.fromEntries(searchParams), filter: true })}>
                                    <div className="text-[#12B76A] text-base"># of invoices issued</div>
                                    <div className=" text-lg  underline cursor-pointer">
                                        {bulkTransaction?.invoice_issue_count}
                                    </div>
                                </div>
                                <div className="px-8 py-4 text-center cursor-pointer" onClick={() => setSearchParams({ ...Object.fromEntries(searchParams), filter: false })}>
                                    <div className="text-[#F04438] text-base"># of invoices failed</div>
                                    <div className="text-lg  underline cursor-pointer">
                                        {bulkTransaction?.invoice_failed_count}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mainDataCntnrListDiv">
                            <InvoiceIssueStatusTable
                                total_count={totalRecords}
                                items={bulkInvoiceDetails}
                                loading={loadingTable}
                                setSearchParams={setSearchParams}
                                searchParams={searchParams}
                                handleOnClickPageNumber={ handleOnClickPageNumber}
                                isSectionIssued={isSectionIssued}
                            />
                        </div>
                    </div>  
                ) : (
                    <div className="flex justify-center items-center h-64">   
                        <p className="text-gray-500">No Details Found</p>
                    </div>
                )}
            </Suspense> 
        </CardHeader>
    );
}; 


export default InvoiceIssueStatus; 